import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const handleOrderConfirmationResult = createAction("".concat(stateName, "/handleOrderConfirmationResult"));
export const fetchConfigurationRequest = createAction("".concat(stateName, "/fetchConfigurationRequest"));